<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticketorigin')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <TicketoriginForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import TicketoriginForm from '../../components/ticketorigin/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Ticketorigin';

const { mapFields } = createHelpers({
  getterType: 'ticketorigin/getField',
  mutationType: 'ticketorigin/updateField'
});

export default {
  name: 'TicketoriginCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    TicketoriginForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('ticketorigin', ['create', 'reset'])
  }
};
</script>
